export default __webpack_public_path__ + "static/media/Ellipse.f24b73f4.svg";